// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	//menu gallery
	menuLinksInteraction();

	//menu or booking sections
	//close
	let allClose = document.getElementsByClassName('close-js');
	for(let i =0; i < allClose.length; i++){
		allClose[i].addEventListener('click', function(){
			let section = this.parentElement.parentElement;
			section.classList.remove('open');
		})
	}
	//menu open
	document.getElementsByClassName('cta-js')[0].addEventListener('click', function(){
		document.getElementsByClassName('navigation-js')[0].classList.add('open');
	})
	//booking open
	document.getElementsByClassName('booking-js')[0].addEventListener('click', function(){
		document.getElementsByClassName('booking-block-js')[0].classList.add('open');
	})

	//GDPR forms 
	// if(document.getElementById('formRFP_yes-signup-form')){
	// 	document.getElementById('formRFP_yes-signup-form').classList.add('required')
	// }
	// if(document.getElementById('frmContact_yes-signup-form')){
	// 	document.getElementById('frmContact_yes-signup-form').classList.add('required')
	// }

	$(document).ready(function () {
		var start = $('#arriveInput').attr('value');
		var end = $('#departureInput').attr('value');
		var firstClick = 0; 

		var closeDates = ['03/08/2020','03/09/2020','03/10/2020','03/11/2020','03/12/2020','03/13/2020','03/14/2020','03/15/2020','03/16/2020','03/17/2020','03/18/2020','03/19/2020','03/20/2020','03/21/2020','03/22/2020','03/23/2020','03/24/2020','03/25/2020','03/26/2020','03/27/2020','03/28/2020','03/29/2020'];
		
		$('#calendarBlock').datepicker({
			minDate: start,
			numberOfMonths:2,
			dateFormat: 'mm/dd/yy',
			maxDate:'+1Y',
			beforeShowDay:function(date){
				setTimeout(function() {
					document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
						e.setAttribute('tabindex', '-1');
					})
				}, 1000);

				var string = jQuery.datepicker.formatDate('mm/dd/yy', date);
				
				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate('mm/dd/yy', start);
				var endDate = $.datepicker.parseDate('mm/dd/yy', end);
				
				if(date.getTime() == startDate.getTime()){
					return[true,"start-day"];
				} else {
					if(date.getTime() == endDate.getTime()){
						return[true,"end-day"];
					} else {
						if(date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()){
							return[true,"days"];
						} else {
							//return[true,""];
							return [closeDates.indexOf(string) == -1];
						}
					}
				}
				
				
				
			},
			onSelect: function(date){
				
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if(firstClick == 0){
					start = date;
					end = date;
					firstClick = 1;
				} else {
					if(selectedDate <= start){
						end =  start;
						start = date;  
					} else {
						end =  date; 
					}
					firstClick = 0;
					checkNights();
				}

				$('#arriveInput').attr('value',start);
				$('#departureInput').attr('value',end);
				$('#fakeInput').attr('value',start +'-'+ end);

				
			}
		});

		var date_diff_indays = function(date1, date2) {
			var dt1 = new Date(date1);
			var dt2 = new Date(date2);
			return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
		}

		$('#fakeInput').on('change',function(){
			let thisvalue = $(this).val();
			start = thisvalue.split('-')[0];
			end = thisvalue.split('-')[1];
			$('#calendarBlock').datepicker('refresh' );
			$('#arriveInput').attr('value',thisvalue.split('-')[0]);
			$('#departureInput').attr('value',thisvalue.split('-')[1]);
			checkNights();
		});

		function checkNights(){
			if(date_diff_indays(start,end) == 1){
				$('#nights').html('1 Night');
			} else {
				$('#nights').html(date_diff_indays(start,end)+' Nights');
			}
		}

		
		
	});

	

	//default bottom content
	if(document.getElementsByClassName('bottom-inset').length > 0){
		document.getElementsByClassName('bottom-inset')[0].getElementsByTagName('h2')[0].setAttribute('data-number','03')
	}

	//accordeon
	if(document.getElementsByClassName('accordeon').length > 0){
		//init
		let accordeonItemActive = document.getElementsByClassName('accordeon')[0].getElementsByClassName('item')[0];
		let initHeight = accordeonItemActive.getElementsByClassName('description')[0].clientHeight + 50;
		accordeonItemActive.style.height = initHeight + 'px';
		let accordeonItems = document.getElementsByClassName('accordeon')[0].getElementsByClassName('item');
		let accordeonImages = document.getElementsByClassName('accordeon')[0].getElementsByClassName('image-slide');
		for(let i = 0; i < accordeonItems.length; i++){
			accordeonItems[i].addEventListener('click',function(){
				let currenTarget = this.getAttribute('data-target');
				let itemtHeight = this.getElementsByClassName('description')[0].clientHeight + 50;
				for(let j = 0; j < accordeonItems.length; j++){
					accordeonItems[j].classList.remove('active');
					accordeonItems[j].style.height = '50px';
				}
				this.classList.add('active');
				this.style.height = itemtHeight + 'px';
				for(let m = 0; m < accordeonImages.length; m++){
					if(accordeonImages[m].getAttribute('data-target') == currenTarget ){
						accordeonImages[m].classList.add('active');
					} else {
						accordeonImages[m].classList.remove('active');
					}
				}
			});
		}
	}

	window.onload = function() {
		// scrollDownAction(20, 'scroll');
		scrollW();
		resizeWindow()
		window.addEventListener('scroll', function(){
			scrollW();
		})
		window.addEventListener('resize', function(){
			resizeWindow();
		});
		
	};

}());

function resizeWindow() {

}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('up')){
				//document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.add('up');
			}
		// } else {
		// 	// upscroll code
		// 	if(document.getElementById('header').classList.contains('up')){
		// 		//document.getElementById('header').classList.add('up');
		// 		document.getElementById('header').classList.remove('up');
		// 	}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			//document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('up');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function menuLinksInteraction(){
	if(document.getElementsByClassName('menu-gallery__item').length > 0){
		//ini
		let ini = 0;
		let allPrimaryA = document.getElementById('primary-nav').getElementsByTagName('a');
		let allGalleryI = document.getElementsByClassName('menu-gallery__item');
		for(let i = 0;i < allPrimaryA.length; i++ ){
			if(allPrimaryA[i].classList.contains('active')){
				allGalleryI[i].classList.add('active');
				ini = 1;
			}
		}
		if(ini == 0){
			allGalleryI[0].classList.add('active');
		} 
		//hover
		for(let i = 0;i < allPrimaryA.length; i++ ){
			allPrimaryA[i].addEventListener('mouseenter', function(e){
				for(let j = 0;j < allGalleryI.length; j++){
					allGalleryI[j].classList.remove('active')
				}
				allGalleryI[i].classList.add('active')
			})
		}
	}
	
}